<div
  class="card"
  [ngClass]="size()"
  [class.inner-card]="innerCard()"
  [class.variant-secondary]="variant() === 'secondary'"
  [class.variant-tertiary]="variant() === 'tertiary'"
>
  @if (headerTemplate() || title()) {
    <div class="card-header">
      @if (headerTemplate()) {
        <ng-container *ngTemplateOutlet="headerTemplate()"></ng-container>
      } @else if (title()) {
        <h2 [innerHTML]="title()"></h2>
      }
      <ng-content select="[card-header]"></ng-content>
    </div>
  }

  @if (!hideBody()) {
    <div class="card-body">
      @if (description()) {
        <div
          class="card-description"
          [innerHTML]="description()"
        ></div>
      }
      <ng-content></ng-content>
    </div>
  }
</div>
